@use '@css/variables';


.hero
{
  position: relative;
  width: 100%;

  h1, p, div {
    color: white;
  }

  .birthAndDeceased
  {
    i {
      display: inline-block;
      padding: 0 4px;
    }
  }
  .background
  {
    background-color: #aaa38d;
    position: absolute;
    overflow: hidden;
    height: 100%;
    width: 100%;

    svg.shape {
      position: absolute;
      height: 100%;
      width: auto;


      right: 54px;
      transform: scale(1.55);

      path {
        fill: #D5CFBD;
        opacity: .3;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .backgroundClaimed {
    &:after {
      content: "";
      opacity: 0.3;
      background: #000;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .wrapper
  {
    height: 100%;
    padding: 4.5rem 0;
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: center;

    .avatar {

      position: relative;
      margin: auto;
      height: 140px;
      width: 140px;
      border: 4px solid white;
      border-radius: 100%;
      background-color: var(--beige);
      //background-color: rgba(var(--beige), 0.5);
      overflow: hidden;

      img {
        border-radius: 100%;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }

      .avatarPlaceholder {
        width: 100%;
        height: 100%;
        fill: var(--beigedark);
      }
    }


  }

  &.claimed {
    .wrapper
    {

      text-align: center;

      .stats {
        justify-content: center;
      }

    }

  }
}


@media only screen and (min-width: variables.$md-breakpoint) {

  .hero.claimed
  {

    .avatar {
      position: absolute;
      bottom: -40px;
      left: 15px;
      height: 240px;
      width: 240px;
    }
    .wrapper {
      padding-left: 240px;
    }
  }
}
